var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgString = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "currentcolor",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.25 3A.75.75 0 0 1 3 2.25h10a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0V3.75h-3.5v8.5H10a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1 0-1.5h1.25v-8.5h-3.5V5a.75.75 0 0 1-1.5 0V3z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgString);
export default ForwardRef;